import { combineReducers } from "redux";
import alertReducer from "../components/Alert/alertReducer";
import settingsReducer from "../components/Settings/settingsReducer";
import notificationsReducer from "../components/Notification/notificationReducer";
import labelsReducer from "../components/Labels/labelsReducer";

const rootReducer = combineReducers({
  alerts: alertReducer,
  settings: settingsReducer,
  labels: labelsReducer,
  notifications: notificationsReducer,
});

export default rootReducer;
